import dividedAsset from '../dividedAsset/dividedAssetManager';
import {getActiveIndustries} from './reducer';
import {PIE_DONUT_TRESHOLD} from '../config';
import zoomcluster from '../map/zoomcluster';
import interaction from '../mapData/interaction';
import overlay from '../popup/overlay';

export const VALUE_FIELD = 'total'; //tmp shit
export const GROUP_FIELD = 'iedz0-1'; //'Apaksnozar';
import {CYAN200, LIGHTBLUE} from '../colors';

import Style from 'ol/style/Style';
import Circle from 'ol/style/Circle';
import Stroke from 'ol/style/Stroke';
import Fill from 'ol/style/Fill';
import Chart from '../chartStyle/index';

var oldIndustries = [];
var oldRadius = 0;

var RequestCount = 0; //to prevent dublicate requests

const SUMPROPS = [
/*	"iedz0-1",
	"iedz2-4",
	"iedz5-6",
	"iedz7-12",
	"iedz13-15",
	"iedz16-18",
	"iedz19-25",
	"iedz26-30",
	"iedz31-62",*/
	"iedz0_6",
	"iedz7_18",
	"iedz19_62",
	"iedz63"
];

const testStyle = new Style({
		text: new Text({
			textBaseline: 'Middle',
		//	offsetX: -2,
			offsetY: 2 + parseInt(10/5),
			fill: new Fill({
			  color: 'white',
			})
		  }),
		image: new Circle({
		  radius: 10,
		  stroke: new Stroke({
			color: '#47556B',
			opacity: 0.4,
			width: 2.2
		  }),
		  fill: new Fill({
			color: 'rgba(255,255,255,0.75)' //'rgba(99, 148, 212, 1)',//'rgba(0,60,136,0.5)',
		  })
		})
	});

export default class population {

	constructor({map, activeIndustries, colorMap, radiusMod, selectFeature}) {

		this.map = map;
		this.activeIndustries = activeIndustries;
		this.colorMap = colorMap;
		this.radiusModd = radiusMod;

		this.dataLoaded = false;

		this.data = null;

		this.styleCache = {};
		this.VALUE_FIELD = VALUE_FIELD;
		this.GROUP_FIELD = GROUP_FIELD;
		this.selectFeature = selectFeature;

		this.generateStyle = this.generateStyle.bind(this)



		this.da = new dividedAsset({
			style: this.generateStyle,
		//	style: testStyle,
			noneGroup: 'NONE',
			groups: [
				{key: 'close', field: 'level_5'},
				{key: 'med', field: 'level_4'},
				{key: 'far', field: 'level_2'},
			],
			group_id: 'population',
			fullSource: false, //full source - otherwise filtred source
			visible: false
		});

		

		this.interaction = null;
		this.zoomEvent = zoomcluster({ 
			map: this.map, 
			da: this.da, 
			zoomMap:{
				far: 11,
				med: 12,
				close: 13
			}
		});

		this.attachZoomEvent();
		this.stateUpdateHandler = this.stateUpdateHandler.bind(this);
		this.selectStyle = this.selectStyle.bind(this);
		this.radiusFunc = this.radiusFunc.bind(this);
		this.sectorFunc = this.sectorFunc.bind(this);

		this.zoomEventAttached = false;



		this.overlay = overlay();


	}

	loadData() {

		return fetch('api?action=layer&layer=Salaspils_iedzivotaji_output.geojson').then((res) => {

			return res.json();

		}).then((data) => {

			this.data = data;

			this.da.generate(data);

			this.da.drawActiveValidate((props) => {
				return true;
			});

			this.da.setVisible(true);

			var layers = this.da.getLayers();

			for (var i = layers.length - 1; i >= 0; i--) {
			//	layers[i].changed();
				this.map.addLayer(layers[i]);
			}

			this.interaction = interaction({
				map: this.map,
				layers: layers,
				selectFeature: (feature, index) => {
					if(feature) {
						this.selectFeature([feature], SUMPROPS[index]);
					//	this.overlay.setPosition(position);

					} else {
						if(typeof selectFeature !== 'undefined') {
							this.selectFeature([]);
						}
						
					//	this.overlay.setPosition(undefined);
					}
				},
				selectStyle: this.generateStyle, 
				radiusFunc: this.radiusFunc,
				sectorFunc: this.sectorFunc, //return sector values, example: [50, 23, 53]
				pie_donut_treshold: PIE_DONUT_TRESHOLD,
				overlay: overlay()
			});

			if(typeof this.zoomEvent !== 'undefined' ) {
				this.zoomEvent();
			}

			this.map.addInteraction(this.interaction);

			this.da.setZindexBy('total');
			
			this.dataLoaded = true;
		});
	}

	update() {

	/*	if(this.activeIndustries.length === 0) {

			var layersOld = this.da.getLayers();

			for (var i = layersOld.length - 1; i >= 0; i--) {
				this.map.removeLayer(layersOld[i]);
			}

			this.da.generate({features:[]});	

			this.da.drawActiveValidate((props) => {
				return true;
			});



			return;
		}*/

		if(this.overlay == null) {
			this.overlay = overlay();
		}

		if(this.data) {

			this.da.drawActiveValidate((props) => {

				return this.isActiveByProps(props);
			});
		}
		
	}

	isActiveByProps(props) {
		for(var key in props) {
			var idx = this.activeIndustries.indexOf(key);

			if(idx > -1 && props[key] > 0 ) {
				return true;
			}
		}

		return false;
	}

	findFeaturesInPieIndex(f, index) {

		var {indexFeatures} = this.getCategoriesSums(f, true, true);

		return indexFeatures[index];
	}

	radiusFunc(f) {

		return this.radiusFromSum(this.getCategoriesSums(f, false));
	}

	sectorFunc(f) {

		var {catArray} = this.getCategoriesSums(f);

		return catArray;
	}

	selectStyle(f, res) {



		return this.generateStyle(f, resolution, selectIndex);
	}

	changes(newIndustries, radiusMod) {




		if (newIndustries.length !== oldIndustries.length) {

			oldIndustries = newIndustries;
			return true;

		} else {

			for (var i = newIndustries.length - 1; i >= 0; i--) {
				if(oldIndustries.indexOf(newIndustries[i]) === -1) {

					return true;
				}
			}
		}

		return false;
	}

	stateUpdateHandler({activeIndustries, colorMap, radiusMod, selectFeature}) {

		if(!this.dataLoaded && activeIndustries.length > 0) {
			
			this.loadData().then(()=>{

				console.log('THEN TEST');
			});
		}

		if( !this.dataLoaded) {

		}

		if (oldRadius !== radiusMod) {

			oldRadius = radiusMod;
			this.radiusMod = radiusMod;

			var layersOld = this.da.getLayers();

			for (var i = layersOld.length - 1; i >= 0; i--) {
				layersOld[i].changed();
			}

		}



		if(!this.changes(activeIndustries, radiusMod)) {
			return;
		}

		if(this.interaction !== null) {
			this.interaction.clear();
		}

		this.activeIndustries = activeIndustries;
		this.colorMap = colorMap;
		this.styleCache = {};
		
		this.selectFeature = selectFeature;

		if(this.overlay == null) {
			
			this.overlay = overlay();
			this.map.addOverlay(this.overlay);
		}

		this.attachZoomEvent();
		this.update();
	}

	attachZoomEvent() {

		if(typeof this.activeIndustries !== 'undefined' && this.activeIndustries.length > 0 && !this.zoomEventAttached) {
			this.zoomEventAttached = true;
			this.map.on('moveend', this.zoomEvent);
		//	this.map.addOverlay(this.overlay);

		} else if(this.zoomEventAttached && typeof this.activeIndustries !== 'undefined' && this.activeIndustries.length === 0) {

			this.zoomEventAttached = false;
			this.map.un('moveend', this.zoomEvent);
		//	this.map.removeOverlay(this.overlay);
		}
	}

	getCategoriesSums(feature, getCatSums = true, pieIndexFeatures = false) {


		var features = feature.getProperties().features;

		var catArray = []; // 
		var catNameIndexValueMap = {}; //category array index map
		var IndexValueCatNameMap = {}; //the same but reversed values keys
		if(pieIndexFeatures) {
			var indexFeatures = [];
		}

		var sum = 0;

		if(typeof features !== 'undefined' && features instanceof Array) { //array
		
			var featuresSums = {}
			var catArray = [];



			for (var i = features.length - 1; i >= 0; i--) {
				var props = features[i].getProperties();

				for(var n = 0, len = SUMPROPS.length; n < len; n++) {

					var sumProp = SUMPROPS[n];
					
					if(typeof featuresSums[sumProp] == 'undefined') {
						featuresSums[sumProp] = 0;
					}

					if(typeof catArray[n] == 'undefined') {
						catArray[n] = 0;
					}

					if(typeof this.activeIndustries == 'undefined') {
						continue;
					}

					var idx = this.activeIndustries.indexOf(sumProp);

					if(idx > -1 && props[sumProp] > 0 ) {
						//return true;
					

						catArray[n] += props[sumProp];

						featuresSums[sumProp] += props[sumProp];

						sum += props[sumProp];
					}


				}
				


				
			}
		}

		if(getCatSums) {
		//	return {catArray, catNameIndexValueMap, IndexValueCatNameMap, sum, indexFeatures};
			return {featuresSums, sum, catArray};	
		} else {
			return sum;
		}
		
	}

	radiusFromSum(sum) {

		sum = sum;

		var intRadius = Math.sqrt(sum / Math.PI) * 28;
		

		var intRadius = intRadius * this.radiusMod;

		if(intRadius < 6){
			intRadius = 6;
		}

		return intRadius;
	}



	generateStyle(f, resolution, selectedSectorIndex = false) {

		return ((feature) => {
			
			var {featuresSums, sum} = this.getCategoriesSums(feature);
			var intRadius = this.radiusFromSum(sum);

			var valueArray = [];
			for(var i = 0, len = SUMPROPS.length; i < len; i++) {

				valueArray.push([featuresSums[SUMPROPS[i]], this.colorMap[SUMPROPS[i]], 1, 0, null, 1]);
			}

			if(valueArray.length === 0) {
				return;
			}

			var strCache = '';
			for (var i = valueArray.length - 1; i >= 0; i--) {
				var valarr = valueArray[i];

				strCache += valarr[0] + '' + valarr[1] + '' + valarr[2] + '' + valarr[3] + '' + valarr[5];
			}
			
			var type = (intRadius <= PIE_DONUT_TRESHOLD ? 'pie' : 'donut');
			

		//	strCache += pieChartState.pieSectors;
			strCache += intRadius;
			strCache += selectedSectorIndex;

			//add cacheing
			if (!this.styleCache[strCache]) {

				// Create chart style
				var style = this.styleCache[strCache] = new Style({
					image: new Chart({
						type: type,
						sectors: false, // pieChartState.pieSectors,
						radius: intRadius, 
						scale: 1,
						offsetY: 0,
						selectedSector: ((selectedSectorIndex !== false) ? selectedSectorIndex : undefined),
						data: valueArray, // [[color, size, xxx, fillpattern, featureRef, xxx], ...]
						colors: 'pastel',
						rotateWithView: true,
						animation: false,
						stroke: new Stroke({	
							color: "#fff",
							width: 2
						}),
					}),
					zIndex: Math.round(1000000 - sum)
				});

			} else {

				var style = this.styleCache[strCache];
			}

			return [style];
		})(f);

	}
}


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/population/populationMap.js